import React, { useState } from 'react'
import { Tooltip } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux'
import Button from 'reactstrap/lib/Button'

const NavbarItem = (props) => {
    const [tooltipOpen, setTooltipOpen] = useState(false)
    const dispatch = useDispatch()
    const cart = useSelector(state => state.payment.cart)
    const toggle = () => setTooltipOpen(!tooltipOpen)

    return (
        <React.Fragment>
            <li
                onClick={() => props.onClick(dispatch)}
                id={props.name}
                style={props.style}
            >
                {props.isButton && (
                    <Button outline className="download-btn">
                        <span>{props.title}</span>
                        <img src={props.image} />
                    </Button>
                )}
                {!props.isButton && props.icon && (
                    <i className={'material-icons'}>{props.icon}</i>
                )}
                {!props.isButton && props.image && <img src={props.image} />}
                {!props.isButton && props.title && <span>{props.title}</span>}
                {props.showCartBadge && cart.length > 0 && <span className="navbar-item__badge">{cart.length}</span>}
            </li>
            {props.tooltip && (
                <Tooltip
                    placement="right"
                    isOpen={tooltipOpen}
                    target={props.name}
                    toggle={toggle}
                >
                    {props.tooltip}
                </Tooltip>
            )}
        </React.Fragment>
    )
}

export default NavbarItem
